/**
 * @module Sagas/UserActivity
 * @desc User activity sagas for /useractivity APIs (dsilo-app-mngmt)
 */
import { put, takeEvery } from 'redux-saga/effects';
import { ActionTypes } from '../constants/index';
import { UserActivityService } from '../modules/api/index';
import { setUserActivitySessionId, setUserActivityPageSessionId } from 'dsilo-ui-components';

function fetchAsync(func, arg) {
  return arg ? func(arg) : func();
}

function* sessionStart(action) {
  try {
    const response = yield fetchAsync(UserActivityService.sessionStart, action.payload);
    const data = response?.data || response;
    const sessionId = data?.sessionId;
    if (sessionId) {
      setUserActivitySessionId(sessionId);
    }
    yield put({
      type: ActionTypes.USER_ACTIVITY_SESSION_START_SUCCESS,
      payload: data
    });
  } catch (e) {
    yield put({
      type: ActionTypes.USER_ACTIVITY_SESSION_START_FAILURE,
      payload: { error: e?.message || 'Session start failed' }
    });
  }
}

function* sessionEnd(action) {
  try {
    const response = yield fetchAsync(UserActivityService.sessionEnd, action.payload);
    yield put({
      type: ActionTypes.USER_ACTIVITY_SESSION_END_SUCCESS,
      payload: response?.data || response
    });
  } catch (e) {
    yield put({
      type: ActionTypes.USER_ACTIVITY_SESSION_END_FAILURE,
      payload: { error: e?.message || 'Session end failed' }
    });
  }
}

function* pageSessionStart(action) {
  try {
    const response = yield fetchAsync(UserActivityService.pageSessionStart, action.payload);
    const data = response?.data ?? response;
    const payload = data?.data ?? data;
    const pageSessionId = payload?.pageSessionId;
    if (pageSessionId) {
      setUserActivityPageSessionId(pageSessionId);
    }
    yield put({
      type: ActionTypes.USER_ACTIVITY_PAGE_SESSION_START_SUCCESS,
      payload: payload || data
    });
  } catch (e) {
    yield put({
      type: ActionTypes.USER_ACTIVITY_PAGE_SESSION_START_FAILURE,
      payload: { error: e?.message || 'Page session start failed' }
    });
  }
}

function* userActivityRecordEvent(action) {
  try {
    const response = yield fetchAsync(UserActivityService.userActivityRecordEvent, action.payload);
    const data = response?.data ?? response;
    const payload = data?.data ?? data;
    yield put({
      type: ActionTypes.USER_ACTIVITY_RECORD_EVENT_SUCCESS,
      payload: payload || data
    });
  } catch (e) {
    yield put({
      type: ActionTypes.USER_ACTIVITY_RECORD_EVENT_FAILURE,
      payload: { error: e?.message || 'Record event failed' }
    });
  }
}

export default function* userActivitySaga() {
  yield takeEvery(ActionTypes.USER_ACTIVITY_SESSION_START, sessionStart);
  yield takeEvery(ActionTypes.USER_ACTIVITY_SESSION_END, sessionEnd);
  yield takeEvery(ActionTypes.USER_ACTIVITY_PAGE_SESSION_START, pageSessionStart);
  yield takeEvery(ActionTypes.USER_ACTIVITY_RECORD_EVENT, userActivityRecordEvent);
}
